import 'novella-agri/src/scss/overview/news-category.scss';

import NewsCategoryMenu from './shared/news-category-menu.js' ;

window.addEventListener('DOMContentLoaded', _ => {
  new NewsCategoryMenu();
});